(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5887],{

/***/ 63938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-leasing/[manufacturer]/[range]",
      function () {
        return __webpack_require__(95592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ FaqAccordionItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
;// CONCATENATED MODULE: ./components/atomic/FaqAccordionItem/FaqAccordionItem.js






var FaqAccordionItem = function(param) {
    var item = param.item, isRequested = param.isRequested;
    var accordionItemRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ( true && isRequested) {
            setTimeout(function() {
                window.scrollTo(0, accordionItemRef.current.offsetTop);
            }, 400);
        }
    }, [
        isRequested
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
        triggerOnce: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: accordionItemRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                uuid: item.slug,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                            children: item.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                            children: item.body
                        })
                    })
                ]
            })
        })
    });
};
FaqAccordionItem.propTypes = {
    item: (prop_types_default()).object.isRequired,
    isRequested: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/atomic/FaqAccordionItem/index.ts



/***/ }),

/***/ 52488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(11783);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/Breadcrumbs.tsx







var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Breadcrumbs = function(param) {
    var crumbs = param.crumbs, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "".concat((breadcrumbs_module_default()).main, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            className: (breadcrumbs_module_default()).crumbs,
            children: [
                crumbs.length > 1 && crumbs.slice(0, crumbs.length - 1).map(function(crumb) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (breadcrumbs_module_default()).crumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                            icon: crumb.icon,
                            href: crumb.slug,
                            hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                            size: system/* Size.Small */.$u.Small,
                            children: crumb.label
                        })
                    }, crumb.slug);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "".concat((breadcrumbs_module_default()).crumb, " ").concat((breadcrumbs_module_default()).current),
                    "aria-current": "page",
                    children: [
                        crumbs[crumbs.length - 1].icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: crumbs[crumbs.length - 1].icon,
                            size: system/* Size.Small */.$u.Small
                        }),
                        crumbs[crumbs.length - 1].label
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/index.ts



/***/ }),

/***/ 48861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* reexport safe */ _VehicleCard__WEBPACK_IMPORTED_MODULE_0__.U; }
/* harmony export */ });
/* harmony import */ var _VehicleCard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63052);



/***/ }),

/***/ 46118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ Carousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-smooth-horizontal-scroll/dist/index.js
var dist = __webpack_require__(36319);
// EXTERNAL MODULE: ./components/styleguide/Carousel/carousel.module.scss
var carousel_module = __webpack_require__(67227);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Carousel/Carousel.tsx









var BrandsModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(535), __webpack_require__.e(1085)]).then(__webpack_require__.bind(__webpack_require__, 11085));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11085)
            ];
        }
    },
    ssr: false
});
var Carousel = function(param) {
    var children = param.children, scrollValue = param.scrollValue, moreLink = param.moreLink, moreLabel = param.moreLabel, sectionName = param.sectionName, header = param.header, onCustomButtonClick = param.onCustomButtonClick, _className = param.className, className = _className === void 0 ? "" : _className, _carouselClass = param.carouselClass, carouselClass = _carouselClass === void 0 ? "" : _carouselClass, _width = param.width, width = _width === void 0 ? "fixed" : _width, _overwriteMoreLabel = param.overwriteMoreLabel, overwriteMoreLabel = _overwriteMoreLabel === void 0 ? false : _overwriteMoreLabel, _showControls = param.showControls, showControls = _showControls === void 0 ? true : _showControls, _triggerScrollUpdate = param.triggerScrollUpdate, triggerScrollUpdate = _triggerScrollUpdate === void 0 ? false : _triggerScrollUpdate, _showMoreButton = param.showMoreButton, showMoreButton = _showMoreButton === void 0 ? true : _showMoreButton;
    var ref = (0,dist/* default */.Z)(), scrollContainerRef = ref.scrollContainerRef, handleScroll = ref.handleScroll, scrollTo = ref.scrollTo, isAtStart = ref.isAtStart, isAtEnd = ref.isAtEnd;
    (0,react.useEffect)(function() {
        window.addEventListener("resize", handleScroll);
        return function() {
            return window.removeEventListener("resize", handleScroll);
        };
    }, [
        handleScroll
    ]);
    (0,react.useEffect)(function() {
        // "jolts" slider to recalculate end and start boolean values
        var refresh = function() {
            return scrollTo(-100);
        };
        var scrollElement = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current;
        scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.addEventListener("load", refresh);
        return function() {
            return scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.removeEventListener("load", refresh);
        };
    }, [
        handleScroll,
        scrollContainerRef,
        scrollTo
    ]);
    (0,react.useEffect)(function() {
        handleScroll();
    }, [
        triggerScrollUpdate,
        handleScroll
    ]);
    var onBrandsMoreClick = function() {
        esm/* default.show */.ZP.show(BrandsModal);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "section-".concat(sectionName, " ").concat((carousel_module_default()).container, " ").concat(className),
        "data-width": width,
        "data-section-name": sectionName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((carousel_module_default()).top, " ").concat(!header ? (carousel_module_default())["no-header"] : ""),
                children: [
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (carousel_module_default()).title,
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "buttons ".concat((carousel_module_default())["button-group"]),
                        children: [
                            showMoreButton && (sectionName === "brands" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: onBrandsMoreClick,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                label: "More"
                            }) : sectionName === "snaps" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: onCustomButtonClick,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                label: "I'm not interested"
                            }) : moreLink && moreLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* InternalLink */.h, {
                                href: moreLink,
                                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                size: system/* Size.Small */.$u.Small,
                                hasPadding: true,
                                hasBackground: true,
                                children: [
                                    overwriteMoreLabel ? moreLabel : "More",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "sr-only",
                                        children: [
                                            " ",
                                            moreLabel
                                        ]
                                    })
                                ]
                            })),
                            showControls && !(isAtStart && isAtEnd) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (carousel_module_default()).controls,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((carousel_module_default())["button-left"], " ").concat(isAtStart ? (carousel_module_default()).disabled : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            icon: "ChevronLeft",
                                            hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                            size: system/* Size.Small */.$u.Small,
                                            onClick: function() {
                                                return scrollTo(-scrollValue);
                                            },
                                            disabled: isAtStart
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((carousel_module_default())["button-right"], " ").concat(isAtEnd ? (carousel_module_default()).disabled : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            icon: "ChevronRight",
                                            hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                                            size: system/* Size.Small */.$u.Small,
                                            onClick: function() {
                                                return scrollTo(scrollValue);
                                            },
                                            disabled: isAtEnd
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((carousel_module_default()).carousel, " ").concat(carouselClass),
                onScroll: handleScroll,
                ref: scrollContainerRef,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Carousel/index.ts



/***/ }),

/***/ 40971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ SearchContentHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/styleguide/SearchContentHeader/search-content-header.module.scss
var search_content_header_module = __webpack_require__(85033);
var search_content_header_module_default = /*#__PURE__*/__webpack_require__.n(search_content_header_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./components/views/SearchBreadcrumbs/search-breadcrumbs.module.scss
var search_breadcrumbs_module = __webpack_require__(50997);
var search_breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(search_breadcrumbs_module);
// EXTERNAL MODULE: ./components/styleguide/Breadcrumbs/index.ts + 1 modules
var Breadcrumbs = __webpack_require__(52488);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
;// CONCATENATED MODULE: ./components/views/SearchBreadcrumbs/SearchBreadcrumbs.js





var SearchBreadcrumbs = function(param) {
    var pageContent = param.pageContent, isVans = param.isVans;
    var ref = (0,react.useState)([
        {
            icon: "ChevronLeft",
            label: isVans ? "Van leasing" : "Car leasing",
            slug: isVans ? routes/* ROUTES.vanSearchPage.url */.Z.vanSearchPage.url : routes/* ROUTES.carSearchPage.url */.Z.carSearchPage.url
        }, 
    ]), breadcrumbs = ref[0], setBreadcrumbs = ref[1];
    (0,react.useEffect)(function() {
        var crumbs = [];
        if (!!pageContent && !!pageContent.breadcrumbLabel1) {
            crumbs.push({
                label: pageContent.breadcrumbLabel1,
                slug: !!pageContent.breadcrumbUrlKey1 && !!pageContent.breadcrumbLabel2 ? "/".concat(pageContent.breadcrumbUrlKey1) : null
            });
            if (pageContent.breadcrumbLabel2) {
                crumbs.push({
                    label: pageContent.breadcrumbLabel2,
                    slug: null
                });
            }
        } else {
            crumbs.push({
                label: "".concat(isVans ? "Van " : "Car ", "Search"),
                slug: null
            });
        }
        setBreadcrumbs(crumbs);
    }, [
        pageContent,
        isVans
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
        hasPadding: false,
        className: (search_breadcrumbs_module_default()).main,
        crumbs: breadcrumbs
    });
};

;// CONCATENATED MODULE: ./components/views/SearchBreadcrumbs/index.js


// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/selectors/search.js
var selectors_search = __webpack_require__(29906);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/SearchContentHeader/SearchContentHeader.tsx

















var SearchContentHeader = function(param) {
    var pageContent = param.pageContent, isVans = param.isVans, _showBreadcrumbs = param.showBreadcrumbs, showBreadcrumbs = _showBreadcrumbs === void 0 ? true : _showBreadcrumbs, _showLinks = param.showLinks, showLinks = _showLinks === void 0 ? true : _showLinks, _isBottom = param.isBottom, isBottom = _isBottom === void 0 ? false : _isBottom;
    var ref;
    var ref1 = (0,react.useState)(false), isIntroContentFullyVisible = ref1[0], setIsIntroContentFullyVisible = ref1[1];
    var searchContent = (0,es/* useSelector */.v9)(selectors_search/* selectSearchResultDeals */.yw);
    var ref2 = (0,react.useState)(pageContent.extra ? pageContent.intro.concat("\n").concat(pageContent.extra) : pageContent.intro), content = ref2[0], setContent = ref2[1];
    (0,react.useEffect)(function() {
        setContent(pageContent.extra ? pageContent.intro.concat("\n").concat(pageContent.extra) : pageContent.intro);
    }, [
        pageContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!pageContent && !!((ref = searchContent[0]) === null || ref === void 0 ? void 0 : ref.range) && searchContent.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: '\n          {\n            "@context":"http://www.schema.org",\n            "@type":"Product",\n            "brand":"'.concat(searchContent[0].manufacturer, '",\n            "logo":"').concat(pageContent.image, '",\n            "name":"').concat(searchContent[0].manufacturer, " ").concat(searchContent[0].range, '",\n            "category":"').concat(searchContent[0].manufacturer, '",\n            "image":"').concat((0,vehicle/* getVehicleHeroImage */.Nk)(searchContent[0].profileImage), '",\n            "description":"').concat(searchContent[0].manufacturer, " ").concat(searchContent[0].range, ' offers, personal pricing inc. VAT.",\n            "offers":{\n              "@type":"AggregateOffer",\n              "lowPrice":"').concat(searchContent[0].profile.leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (0,search/* addVatToPrice */.QR)(searchContent[0].profile.price) : searchContent[0].profile.price.toFixed(2), '",\n              "priceCurrency":"GBP"\n            }\n          }\n        ')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        children: '\n          {\n            "@context":"http://schema.org",\n            "@type":"Car",\n            "name":"'.concat(searchContent[0].manufacturer, " ").concat(searchContent[0].range, '",\n            "aggregateRating":{\n                "@type":"AggregateRating",\n                "ratingValue":"').concat(searchContent[0].rating, '",\n                "bestRating":"100",\n                "ratingCount":"').concat(searchContent.length, '"\n            }\n          }\n        ')
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((search_content_header_module_default()).main, " ").concat(isBottom ? (search_content_header_module_default()).bottom : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (search_content_header_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_content_header_module_default()).content,
                            children: [
                                showBreadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBreadcrumbs, {
                                    isVans: isVans,
                                    pageContent: pageContent
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: !(0,utilities_system/* isProd */.BB)() ? "search-content__h1" : "",
                                    children: pageContent.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_content_header_module_default()).body,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                                            className: "".concat((search_content_header_module_default()).markdown, " ").concat(isIntroContentFullyVisible ? (search_content_header_module_default()).show : ""),
                                            children: content
                                        }),
                                        !isIntroContentFullyVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: (search_content_header_module_default()).button,
                                            onClick: function() {
                                                return setIsIntroContentFullyVisible(true);
                                            },
                                            children: "Read more"
                                        })
                                    ]
                                })
                            ]
                        }),
                        showLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_content_header_module_default()).links,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_content_header_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (search_content_header_module_default()).image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/amazon-reward.png"),
                                                alt: "",
                                                height: 36,
                                                width: 36
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (search_content_header_module_default()).link,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "\xa320 Amazon voucher with every lease"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                                    href: routes/* ROUTES.rewardsAndReferralsPage.url */.Z.rewardsAndReferralsPage.url,
                                                    hierarchy: Button/* ButtonHierarchy.Bezeled */.B.Bezeled,
                                                    size: system/* Size.Medium */.$u.Medium,
                                                    children: "More about LocoRewards"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (search_content_header_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (search_content_header_module_default()).image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/wink-with-background.png"),
                                                alt: "",
                                                height: 36,
                                                width: 36
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (search_content_header_module_default()).link,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Road tax & breakdown cover included"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                                    href: routes/* ROUTES.whyLeasePage.url */.Z.whyLeasePage.url,
                                                    size: system/* Size.Medium */.$u.Medium,
                                                    hierarchy: Button/* ButtonHierarchy.Bezeled */.B.Bezeled,
                                                    children: "Learn more benefits of leasing"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/SearchContentHeader/index.ts



/***/ }),

/***/ 95592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _range_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/atomic/PageMetaData/index.ts + 1 modules
var PageMetaData = __webpack_require__(1429);
// EXTERNAL MODULE: ./components/styleguide/Header/index.ts + 9 modules
var Header = __webpack_require__(638);
// EXTERNAL MODULE: ./components/styleguide/SearchContentHeader/index.ts + 3 modules
var SearchContentHeader = __webpack_require__(40971);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/views/MakeModelLanding/Banner/banner.module.scss
var banner_module = __webpack_require__(63215);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Banner/Banner.tsx





var Form = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(3036)]).then(__webpack_require__.bind(__webpack_require__, 43036));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43036)
            ];
        }
    },
    ssr: false
});
var Banner = function(param) {
    var vehicleModelContent = param.vehicleModelContent, range = param.range;
    var manufacturerName = range.manufacturerName, rangeName = range.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (banner_module_default())["section-banner"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (banner_module_default()).grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (banner_module_default()).form,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            children: [
                                (0,search/* capitaliseFirstLetter */.zd)(manufacturerName),
                                " ",
                                (0,search/* capitaliseFirstLetter */.zd)(rangeName),
                                " lease deals"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                            range: range
                        })
                    ]
                }),
                vehicleModelContent.heroSectionImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (banner_module_default()).image,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: vehicleModelContent.heroSectionImage,
                        alt: "".concat(manufacturerName, " ").concat(rangeName),
                        layout: "fill",
                        objectFit: "cover"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Banner/index.ts


// EXTERNAL MODULE: ./components/views/MakeModelLanding/Ctas/ctas.module.scss
var ctas_module = __webpack_require__(83755);
var ctas_module_default = /*#__PURE__*/__webpack_require__.n(ctas_module);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Ctas/Ctas.tsx






var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Ctas = function(param) {
    var supplierCount = param.supplierCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (ctas_module_default())["section-cta"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ctas_module_default()).grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ctas_module_default()).item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            size: system/* Size.ExtraLarge */.$u.ExtraLarge,
                            name: "PartyPopper",
                            customClass: (ctas_module_default()).icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Save \xa3484/month vs PCP"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Last year our customers saved big each month compared to other finance options for their new car."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* ExternalLink */.d, {
                            size: system/* Size.Large */.$u.Large,
                            hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                            href: "https://www.leaseloco.com/pcp-savings",
                            className: (ctas_module_default()).link,
                            target: "_blank",
                            children: "Learn more"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ctas_module_default()).item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            size: system/* Size.ExtraLarge */.$u.ExtraLarge,
                            name: "CircleCheck",
                            customClass: (ctas_module_default()).icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Get the best value for money"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Configure your car the way you want, without ever second-guessing a good deal with our LocoScore."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* ExternalLink */.d, {
                            size: system/* Size.Large */.$u.Large,
                            hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                            href: "https://www.leaseloco.com/loco-score",
                            className: (ctas_module_default()).link,
                            target: "_blank",
                            children: "Learn more"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ctas_module_default()).item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            size: system/* Size.ExtraLarge */.$u.ExtraLarge,
                            name: "Star",
                            customClass: (ctas_module_default()).icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "See real-time deals across the UK"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "With ",
                                supplierCount,
                                " providers and millions of deals you're sure to find the very best deal at LeaseLoco."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* ExternalLink */.d, {
                            size: system/* Size.Large */.$u.Large,
                            hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                            href: "https://www.leaseloco.com/partner-criteria",
                            className: (ctas_module_default()).link,
                            target: "_blank",
                            children: "Learn more"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Ctas/index.ts


// EXTERNAL MODULE: ./node_modules/react-markdown/src/react-markdown.js
var react_markdown = __webpack_require__(38456);
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);
// EXTERNAL MODULE: ./components/views/MakeModelLanding/VehicleDeals/vehicle-deals.module.scss
var vehicle_deals_module = __webpack_require__(85026);
var vehicle_deals_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_deals_module);
// EXTERNAL MODULE: ./components/styleguide/Card/Vehicle/index.ts
var Vehicle = __webpack_require__(48861);
// EXTERNAL MODULE: ./components/styleguide/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(46118);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/VehicleDeals/VehicleDeals.tsx





var VehicleDeals = function(param) {
    var isVans = param.isVans, title = param.title, content = param.content, dealList = param.dealList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (vehicle_deals_module_default()).header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                    children: content
                })
            ]
        }),
        scrollValue: 344,
        moreLink: "/".concat(isVans ? "van" : "car", "-leasing/search"),
        moreLabel: "See more",
        overwriteMoreLabel: true,
        sectionName: "vehicle-deals",
        className: (vehicle_deals_module_default()).carousel,
        children: dealList.length ? dealList.map(function(deal) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Vehicle/* VehicleCard */.U, {
                deal: deal,
                type: "vehicle-deals"
            }, deal.vehiclePrice.id);
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (vehicle_deals_module_default()).loader
        })
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/VehicleDeals/index.ts


// EXTERNAL MODULE: ./components/views/MakeModelLanding/Stats/stats.module.scss
var stats_module = __webpack_require__(67216);
var stats_module_default = /*#__PURE__*/__webpack_require__.n(stats_module);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Stats/Stats.tsx




var Stats = function(param) {
    var vehicleModelContent = param.vehicleModelContent, technicalData = param.technicalData, vehicle = param.vehicle;
    var ref, ref1, ref2;
    var dataPoints = [
        {
            metric: "Seconds",
            value: ((ref = technicalData[12]) === null || ref === void 0 ? void 0 : ref.displayValue) ? technicalData[12].displayValue : "---",
            label: "Acceleration from (0-62mph)"
        },
        {
            metric: "Bph",
            value: ((ref1 = technicalData[21]) === null || ref1 === void 0 ? void 0 : ref1.displayValue) ? technicalData[21].displayValue : "---",
            label: "Power up to"
        },
        {
            metric: "Mph",
            value: ((ref2 = technicalData[13]) === null || ref2 === void 0 ? void 0 : ref2.displayValue) ? technicalData[13].displayValue : "---",
            label: "Top Speed"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (stats_module_default())["stats-section"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (stats_module_default()).grid,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (stats_module_default()).text,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                        children: vehicleModelContent.firstBodyContent
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (stats_module_default()).info,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (stats_module_default()).grid,
                    children: [
                        vehicleModelContent.performanceSectionImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (stats_module_default()).image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: vehicleModelContent.performanceSectionImage,
                                alt: "Performance image",
                                layout: "fill",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (stats_module_default()).stats,
                            children: dataPoints.map(function(point, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (stats_module_default()).stat,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (stats_module_default()).title,
                                            children: point.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (stats_module_default()).value,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: point.value
                                                }),
                                                " ",
                                                point.metric
                                            ]
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (stats_module_default()).subtitle,
                            children: [
                                "The above performance data relates to the ",
                                vehicle.manufacturerName,
                                " ",
                                vehicle.modelName,
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Stats/index.ts


// EXTERNAL MODULE: ./components/views/MakeModelLanding/Content/content.module.scss
var content_module = __webpack_require__(4250);
var content_module_default = /*#__PURE__*/__webpack_require__.n(content_module);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Content/Content.tsx




var Content = function(param) {
    var vehicleModelContent = param.vehicleModelContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (content_module_default())["content-section"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (content_module_default()).grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (content_module_default()).intro,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                        children: vehicleModelContent.secondBodyContent
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (content_module_default()).section,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (content_module_default()).text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (content_module_default()).content,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_markdown_default()), {
                                    children: vehicleModelContent.smallParagraph
                                })
                            })
                        }),
                        vehicleModelContent.smallParagraphImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (content_module_default()).image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: vehicleModelContent.smallParagraphImage,
                                alt: "Content image",
                                layout: "fill",
                                objectFit: "cover"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Content/index.ts


// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var dist_es = __webpack_require__(11876);
// EXTERNAL MODULE: ./components/atomic/FaqAccordionItem/index.ts + 1 modules
var FaqAccordionItem = __webpack_require__(72201);
// EXTERNAL MODULE: ./components/views/MakeModelLanding/Faqs/faqs.module.scss
var faqs_module = __webpack_require__(95457);
var faqs_module_default = /*#__PURE__*/__webpack_require__.n(faqs_module);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Faqs/Faqs.tsx





var Faqs = function(param) {
    var faqList = param.faqList;
    var ref = (0,react.useState)([]), activeFaqs = ref[0], setActiveFaqs = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (faqs_module_default())["section-faqs"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (faqs_module_default()).grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (faqs_module_default()).text,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "your questions, answered"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((faqs_module_default()).faqs, " make-model-faqs"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_es/* Accordion */.UQ, {
                        allowZeroExpanded: true,
                        preExpanded: activeFaqs,
                        onChange: function(value) {
                            return setActiveFaqs(value);
                        },
                        children: faqList.length > 0 && faqList.map(function(faq) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqAccordionItem/* FaqAccordionItem */.Q, {
                                item: faq,
                                isActive: activeFaqs.includes(faq.slug)
                            }, faq.slug);
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/Faqs/index.ts


// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var reducers_search = __webpack_require__(29109);
// EXTERNAL MODULE: ./lib/services/searchService.js
var searchService = __webpack_require__(74829);
// EXTERNAL MODULE: ./lib/services/vehicleService.js
var vehicleService = __webpack_require__(68292);
// EXTERNAL MODULE: ./components/views/MakeModelLanding/styles.module.scss
var styles_module = __webpack_require__(8486);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/views/MakeModelLanding/MakeModelLanding.tsx


















var Colour = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6053).then(__webpack_require__.bind(__webpack_require__, 6053));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6053)
            ];
        }
    },
    ssr: false
});

var MakeModelLanding = function(param) {
    var isVans = param.isVans, vehicleModelContent = param.vehicleModelContent, range = param.range, faqList = param.faqList, supplierCount = param.supplierCount;
    var manufacturer = range.manufacturer, manufacturerName = range.manufacturerName, rangeId = range.id, rangeName = range.name;
    var ref = (0,react.useState)([]), dealList = ref[0], setDealList = ref[1];
    var ref1 = (0,react.useState)([]), secondDealList = ref1[0], setSecondDealList = ref1[1];
    var ref2 = (0,react.useState)(null), technicalData = ref2[0], setTechnicalData = ref2[1];
    var vehicle = (0,react.useMemo)(function() {
        var ref;
        return dealList === null || dealList === void 0 ? void 0 : (ref = dealList[0]) === null || ref === void 0 ? void 0 : ref.vehicle;
    }, [
        dealList
    ]);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, allDealsResponse, inStockDealsResponse, allDeals, inStockDeals, technicalResponse, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                Promise.all([
                                    (0,searchService/* submitSearchService */.u9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reducers_search/* INITIAL_STATE.searchParameters */.Y6.searchParameters), {
                                        manufacturers: [
                                            manufacturer
                                        ],
                                        ranges: [
                                            rangeId
                                        ],
                                        grouping: 1
                                    })),
                                    (0,searchService/* submitSearchService */.u9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reducers_search/* INITIAL_STATE.searchParameters */.Y6.searchParameters), {
                                        manufacturers: [
                                            manufacturer
                                        ],
                                        ranges: [
                                            rangeId
                                        ],
                                        grouping: 1,
                                        inStock: 1
                                    }))
                                ])
                            ];
                        case 1:
                            ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), allDealsResponse = ref2[0], inStockDealsResponse = ref2[1];
                            allDeals = (allDealsResponse === null || allDealsResponse === void 0 ? void 0 : allDealsResponse.results) || [];
                            inStockDeals = (inStockDealsResponse === null || inStockDealsResponse === void 0 ? void 0 : inStockDealsResponse.results) || [];
                            setDealList(allDeals);
                            setSecondDealList(inStockDeals);
                            if (!(allDeals.length > 0 && ((ref = allDeals[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.vehicle) === null || ref1 === void 0 ? void 0 : ref1.id))) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (0,vehicleService/* getVehicleTechnicalDataService */.Kr)({
                                    id: allDeals[0].vehicle.id
                                })
                            ];
                        case 2:
                            technicalResponse = _state.sent();
                            setTechnicalData(technicalResponse);
                            _state.label = 3;
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            err = _state.sent();
                            console.error("Failed to fetch data:", err);
                            setDealList([]);
                            setSecondDealList([]);
                            setTechnicalData(null);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        manufacturer,
        manufacturerName,
        rangeId,
        rangeName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                vehicleModelContent: vehicleModelContent,
                range: range
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ctas, {
                supplierCount: supplierCount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).deals,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).container,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            children: [
                                "Best deals for the ",
                                (0,search/* capitaliseFirstLetter */.zd)(manufacturerName),
                                " ",
                                (0,search/* capitaliseFirstLetter */.zd)(rangeName)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDeals, {
                        isVans: isVans,
                        title: "Leasing deals by best value",
                        content: vehicleModelContent.firstCarouselBestDeals,
                        dealList: dealList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDeals, {
                        isVans: isVans,
                        title: "In stock lease deals",
                        content: vehicleModelContent.secondCarouselInStock,
                        dealList: secondDealList
                    })
                ]
            }),
            technicalData && vehicle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stats, {
                vehicleModelContent: vehicleModelContent,
                technicalData: technicalData,
                vehicle: vehicle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                vehicleModelContent: vehicleModelContent
            }),
            dealList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Colour, {
                vehicle: vehicle,
                vehiclePrice: dealList[0].vehiclePrice
            }),
            faqList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs, {
                faqList: faqList
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/MakeModelLanding/index.ts


// EXTERNAL MODULE: ./components/views/SearchResultsAndFilters/index.js + 14 modules
var SearchResultsAndFilters = __webpack_require__(2374);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./pages/car-leasing/[manufacturer]/[range]/index.js











var CarRangePage = function(param) {
    var isAlt = param.isAlt, pageContent = param.pageContent, range = param.range, faqList = param.faqList, supplierCount = param.supplierCount;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(true), showPageContent = ref[0], setShowPageContent = ref[1];
    var ref1 = (0,react.useState)(false), isVans = ref1[0];
    var ref2 = (0,react.useState)(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING), status = ref2[0], setStatus = ref2[1];
    (0,react.useEffect)(function() {
        if (router.query.page) {
            setShowPageContent(false);
        }
    }, [
        router.query.page
    ]);
    (0,react.useEffect)(function() {
        setStatus(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING);
        dispatch((0,reducers_search/* landedOnCarSearchPageWithPath */.o7)(router.asPath));
    }, [
        router.asPath,
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaData/* PageMetaData */.S, {
                title: pageContent.pageTitle,
                pageTitle: pageContent.pageTitle,
                description: pageContent.metaDescription,
                pageUrl: router.asPath.split("?")[0],
                canonical: "".concat("https://www.leaseloco.com").concat(router.asPath.split("?")[0]),
                image: pageContent.image,
                noIndex: isAlt ? true : router.asPath.includes("page=")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                width: isAlt ? "make-model" : "browse",
                backgroundColor: isAlt ? "transparent" : "backdrop",
                hasBorderBottom: "desktop",
                hideNav: isAlt ? "never" : "mobile"
            }),
            isAlt ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MakeModelLanding, {
                isVans: isVans,
                vehicleModelContent: pageContent,
                range: range,
                faqList: faqList,
                supplierCount: supplierCount
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showPageContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContentHeader/* SearchContentHeader */.v, {
                        isVans: isVans,
                        pageContent: pageContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsAndFilters/* SearchResultsAndFilters */.Q, {
                        isVans: isVans,
                        setStatus: setStatus,
                        status: status
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _range_ = (CarRangePage);


/***/ }),

/***/ 11783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"breadcrumbs_main__VBByA","crumbs":"breadcrumbs_crumbs__pJ96J","crumb":"breadcrumbs_crumb__NOO8e","phAnimation":"breadcrumbs_phAnimation__MNg6t"};

/***/ }),

/***/ 67227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel_container__QBa3N","carousel":"carousel_carousel___HIyX","top":"carousel_top__Ejz_R","button-group":"carousel_button-group__KuHj8","controls":"carousel_controls__l6IQd","button-left":"carousel_button-left__dzsFP","button-right":"carousel_button-right__mxuOU","disabled":"carousel_disabled__DhoqA","no-header":"carousel_no-header__qLh0q","phAnimation":"carousel_phAnimation__PK7Jm"};

/***/ }),

/***/ 85033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-content-header_main__W3_qs","bottom":"search-content-header_bottom__y7_Cy","wrapper":"search-content-header_wrapper__Lq1x5","content":"search-content-header_content__WNXr_","markdown":"search-content-header_markdown__vB5sK","show":"search-content-header_show__5gMms","button":"search-content-header_button__naud0","links":"search-content-header_links__CUHe2","item":"search-content-header_item__y7tGO","image":"search-content-header_image__peECC","link":"search-content-header_link__kOQlw","body":"search-content-header_body__UvcSl","phAnimation":"search-content-header_phAnimation__dX2dC"};

/***/ }),

/***/ 63215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-banner":"banner_section-banner__6iQxI","grid":"banner_grid__XrxMs","form":"banner_form__ed9i7","image":"banner_image__OaC3i","phAnimation":"banner_phAnimation__aNp6l"};

/***/ }),

/***/ 4250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-section":"content_content-section__6OAOC","grid":"content_grid__25VMs","intro":"content_intro__q_Jcw","section":"content_section__E65Qk","image":"content_image__WeUq9","text":"content_text__fmMLv","content":"content_content__YZQch","phAnimation":"content_phAnimation__wkghR"};

/***/ }),

/***/ 83755:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section-cta":"ctas_section-cta__jGP7e","grid":"ctas_grid__rg_e0","item":"ctas_item__O8aeH","icon":"ctas_icon__D9vLB","link":"ctas_link__0pAn6","phAnimation":"ctas_phAnimation__XTYj6"};

/***/ }),

/***/ 95457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"faqs_grid__2yL0k","text":"faqs_text__oYXGT","faqs":"faqs_faqs__3gfzf","phAnimation":"faqs_phAnimation__v3Pqs"};

/***/ }),

/***/ 67216:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"stats_grid__sx1CD","text":"stats_text__g8IMw","info":"stats_info__EWnlL","image":"stats_image___JC27","subtitle":"stats_subtitle__0IEKt","stats":"stats_stats__Pf9hL","stat":"stats_stat__fRSQZ","title":"stats_title__6uyUg","value":"stats_value__6_yKC","phAnimation":"stats_phAnimation__OhPN_"};

/***/ }),

/***/ 85026:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"vehicle-deals_carousel__IbjEO","header":"vehicle-deals_header__sp3Qd","loader":"vehicle-deals_loader__UqEBZ","ghost":"vehicle-deals_ghost___0GnA","phAnimation":"vehicle-deals_phAnimation__PWPqH"};

/***/ }),

/***/ 8486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__7GYAl","deals":"styles_deals__YVwUf","container":"styles_container__mY0ix","phAnimation":"styles_phAnimation__OrMl2"};

/***/ }),

/***/ 50997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-breadcrumbs_main__tCJaY","phAnimation":"search-breadcrumbs_phAnimation__81ydH"};

/***/ }),

/***/ 36319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
function ___$insertStyle(e){if(e&&"undefined"!=typeof window){var t=document.createElement("style");return t.setAttribute("type","text/css"),t.innerHTML=e,document.head.appendChild(t),e}}__webpack_unused_export__ = ({value:!0});var react=__webpack_require__(67294),useSmoothHorizontalScroll=function(){var l=react.useRef(null),e=react.useState(!0),t=e[0],n=e[1],r=react.useState(!1),o=r[0],c=r[1];react.useEffect(function(){l.current&&c(l.current.scrollWidth===l.current.offsetWidth)},[l]);return{scrollContainerRef:l,handleScroll:function(){var e,t,r,o;l.current&&(n(0===(null===(e=l.current)||void 0===e?void 0:e.scrollLeft)),c(Math.floor((null===(t=l.current)||void 0===t?void 0:t.scrollWidth)-(null===(r=l.current)||void 0===r?void 0:r.scrollLeft))<=(null===(o=l.current)||void 0===o?void 0:o.offsetWidth)))},scrollTo:function(e){var t,r;null!==(t=l.current)&&void 0!==t&&t.scrollTo({left:(null===(r=l.current)||void 0===r?void 0:r.scrollLeft)+e,behavior:"smooth"})},isAtStart:t,isAtEnd:o}};exports.Z=useSmoothHorizontalScroll;
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1852,5675,1967,264,8456,535,1876,111,638,1429,3052,9758,9774,2888,179], function() { return __webpack_exec__(63938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);